export default {"src":"/_next/static/media/grundriss-schwarz-weiß.0406d684.svg","height":2324,"width":2324,"blurWidth":0,"blurHeight":0};